import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Row } from 'reactstrap';
import Error404 from '../components/errors/Error404';
import Error500 from '../components/errors/Error500';
import bgimage from '../assets/img/bugzero/error-pages-bg.png';

import Section from '../components/common/Section';

const ErrorLayout = ({ match: { url } }) => (
  <Section
    className="py-0"
    style={{ backgroundImage: `url(${bgimage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
  >
    <Row className="min-vh-100 py-6">
      {/* <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5"> */}
      <>
        {/* <Logo /> */}
        <Switch>
          <Route path={`${url}/404`} component={Error404} />
          <Route path={`${url}/500`} component={Error500} />

          {/*Redirect*/}
          <Redirect to={`${url}/404`} />
        </Switch>
      </>
    </Row>
  </Section>
);

ErrorLayout.propTypes = { match: PropTypes.object };

export default ErrorLayout;
